// import * as types from "../actions/types";
// import setAuthUsername, { setAuthToken } from "../config/setAuthUsername";

const initialState = {
  userInfo: null,
  loading: true,
  error: null,
  isLoggedIn: false,
};

const userReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    // case types.LOGIN_USER_SUCCESS:
    // case types.LOGIN_WITH_GOOGLE:
    //   const userInfo = payload;
    //   // on login store userinfo in localstorage
    //   // and set global axios header
    //   localStorage.setItem("userInfo", JSON.stringify(userInfo));
    //   setAuthUsername(payload.username);
    //   setAuthToken(payload.jwtToken);

    //   return {
    //     ...state,
    //     userInfo,
    //     error: null,
    //     loading: null,
    //     isLoggedIn: true,
    //   };

    // case types.REGISTER_USER_SUCCESS:
    //   return {
    //     ...state,
    //     userInfo: null,
    //     error: payload,
    //     loading: false,
    //     isLoggedIn: false,
    //   };
    // case types.REGISTER_USER_FAILURE:
    // case types.LOGIN_USER_FAILURE:
    //   return {
    //     ...state,
    //     userInfo: null,
    //     error: payload,
    //     loading: false,
    //     isLoggedIn: false,
    //   };
    // case types.LOAD_USER_SUCCESS:
    //   return {
    //     ...state,
    //     userInfo: payload,
    //     error: null,
    //     loading: false,
    //     isLoggedIn: true,
    //   };
    // case types.LOAD_USER_FAILURE:
    //   return {
    //     ...state,
    //     userInfo: null,
    //     error: "NOT AUTHORIZED",
    //     loading: false,
    //     isLoggedIn: false,
    //   };
    // case types.LOGOUT_USER:
    //   localStorage.removeItem("userInfo");
    //   return {
    //     ...state,
    //     userInfo: null,
    //     error: null,
    //     isLoggedIn: false,
    //     loading: false,
    //   };
    // case types.CLEAR_ERROR:
    //   return {
    //     ...state,
    //     error: null,
    //   };
    // case types.START_LOADING:
    //   return {
    //     ...state,
    //     loading: true,
    //   };

    default:
      return state;
  }
};

export default userReducer;
